module.exports = __webpack_public_path__ + "img/News_item_3.7974f473.jpg";